<template>
    <v-dialog v-model="show_dialog" ref="save_activity_dialog" scrollable persistent max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-form ref="saveActivityForm" method="post" :action="form.action" v-model="form.valid" v-on:success="success_save_event">
            <v-card>
                <v-card-title
                    class="handline blue darken-2 white--text"
                >
                    <div v-if="form.data.activity_id > 0">{{$t('event.edit_activity')}}</div>
                    <div v-else>{{$t('event.create_activity')}}</div>
                </v-card-title>
                <v-card-text>
                    <input type="hidden" name="event_id" v-model="event_id">
                    <input type="hidden" name="activity_id" v-model="form.data.activity_id">

                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 v-if="form.errors.general!==''">
                                <v-alert
                                        :value="form.errors.general!==''"
                                        type="error"
                                >
                                    {{form.errors.general}}
                                </v-alert>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field
                                        :label="$t('event.activity_name')"
                                        v-model="form.data.activity_name"
                                        :rules="[rules.required]"
                                        :error-messages="form.errors.name"
                                        name="name"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field
                                    :label="$t('event.activity_quota')"
                                    v-model="form.data.activity_quota"
                                    :error-messages="form.errors.quota"
                                    :hint="$t('event.quota_desc')"
                                    persistent-hint
                                    type="number"
                                    name="quota"
                                    clearable
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close_dialog">{{$t('action.close')}}</v-btn>
                    <v-btn color="blue darken-1" flat type="submit" :loading="form.loading" :disabled="!form.valid">{{$t('action.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import {UrlServices} from "~/utils/url-manager";
    import FormHandling from "~/utils/data/form-handling";

    export default {
        name: "SaveActivityDialog",
        props: {
            event_id: Number,
            show_dialog: Boolean,
            save_success_callback: Function,
            activity_item: [Object, Boolean]
        },
        data() {
            return {
                form: {
                    form_handling_object: null,
                    action: UrlServices.createUrl({name: "api_event_activity_save"}),
                    loading: false,
                    valid: false,
                    data: {
                        activity_id: 0,
                        activity_name: "",
                        activity_quota: ""
                    },
                    errors: {
                        general: "",
                        name: "",
                        quota: ""
                    },
                },
                rules: {
                    required: value => (!!value) || this.$t('form.field_required'),
                    integer_required: value => (isNaN(Number(value)) || parseInt(value) > 0) || this.$t('form.integer_required')
                },
            }
        },
        beforeCreate() {
            this.empty_activity_item = {
                id: 0,
                name: "",
                quota: ""
            };
        },
        methods: {
            success_save_event(data) {
                this.save_success_callback(data);
                this.close_dialog();
            },
            close_dialog() {
                this.$refs['saveActivityForm'].reset();
                this.$emit('update:show_dialog', false);
            },
        },
        watch: {
            activity_item: async function(new_activity_item) {
                if(new_activity_item == null){
                    new_activity_item = _.extend({}, this.empty_activity_item);
                    this.form.form_handling_object.formReset();
                    await this.$nextTick();     // Delay the following code so that bindings happen after the form is cleared
                }

                this.form.data = {
                    activity_id: new_activity_item.id,
                    activity_name: new_activity_item.name,
                    activity_quota: new_activity_item.quota
                };
            }
        },
        mounted() {
            this.form.form_handling_object = new FormHandling(this, "saveActivityForm");
        }
    }
</script>